import React, {useState, useEffect} from 'react';
import {useContextSelector} from 'use-context-selector';

import {LocalContext} from '../context/LocalContext';
import {SessionContext} from '../context/SessionContext';

const LoadingBlock = () => {
    const cookiesPolicyAccepted = useContextSelector(LocalContext, v => v[0].cookiesPolicy.accepted);
    const userAuthenticated = useContextSelector(LocalContext, v => v[0].user.authenticated);

    const UILangAuth = useContextSelector(LocalContext, v => (v[0].user.data.UILang ? v[0].user.data.UILang : null));
    const UILangGuest = useContextSelector(LocalContext, v => v[0].UILang);
    const UILangSession = useContextSelector(SessionContext, v => v[0].UILang);

    const [langSourceChecked, setLangSourceChecked] = useState(false);

    const [langSource, setLangSource] = useState(null);

    useEffect(() => {
        if (!langSourceChecked) {
            setLangSourceChecked(true);
            if (cookiesPolicyAccepted) {
                if (userAuthenticated) {
                    setLangSource(UILangAuth);
                } else {
                    setLangSource(UILangGuest);
                }
            } else {
                setLangSource(UILangSession);
            }
        }
    }, [cookiesPolicyAccepted, langSourceChecked, userAuthenticated, UILangAuth, UILangSession, UILangGuest, setLangSourceChecked]);


    const handleComponentLang = () => {
        switch (langSource) {
            case langSource === 'en':
                return 'Loading';
            case langSource === 'lv':
                return 'Ielādē';
            default:
                return 'Loading';
        }
    }

    return (<>
        <div style={{
            display: `flex`,
            alignSelf: `center`,
            color: `rgba(128,128,128, 0.5)`,
            padding: `1rem`
        }}>{handleComponentLang()}</div>
    </>)
}

export default LoadingBlock;
